import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

const Header = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2rem 0;
`;

const Title = styled(Headline)`
  margin-bottom: 2rem;
  line-height: 3rem;
  color: ${pickColor('blackLight')};
`;

const Subtitle = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 0.7rem;
`;

const SeasonInfo = styled.p`
  margin: 0;
  font-size: 1.4rem;
  color: ${pickColor('grayDarkSecondary')};
  white-space: nowrap;
  text-transform: uppercase;
`;

const Content = styled.div`
  padding: 2.4rem 0;
`;

const ProductCount = styled.p`
  font-size: 1.4rem;
  color: ${pickColor('grayDarkSecondary')};
  margin: 1.6rem 0 0.8rem;
`;

const ProductCard = styled.div`
  border: 1px solid ${pickColor('borderExtraLight')};
  border-radius: 1.2rem;
  padding: 1.6rem 2rem;
  margin-bottom: 1.2rem;
`;

const ProductMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2.4rem;
`;

const MetaItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

const MetaLabel = styled.span`
  font-size: 1.1rem;
  color: ${pickColor('grayDarkSecondary')};
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

const MetaValue = styled.span`
  font-size: 1.4rem;
  font-weight: 500;
`;

const ProductDescription = styled.p`
  margin: 1.2rem 0 0;
  padding-top: 1.2rem;
  border-top: 1px solid ${pickColor('borderExtraLight')};
  font-size: 1.4rem;
  line-height: 1.5;
`;

const CTA = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 2.4rem 0;
`;

export {
  Content,
  CTA,
  Header,
  MetaItem,
  MetaLabel,
  MetaValue,
  ProductCard,
  ProductCount,
  ProductDescription,
  ProductMeta,
  SeasonInfo,
  Title,
  Subtitle,
};
